import React, { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Box, Typography } from "@mui/material";
import { Divider } from "@mui/material";
import KeyIcon from "@mui/icons-material/Key";
import LogoutIcon from "@mui/icons-material/Logout";
import Avatar from "react-avatar";
import PropTypes from "prop-types";
import Cookies from "js-cookie";
import colors from "../../theme";
import { fetchUsernameAndEmail } from "../../services/api";
import useSignOut from "react-auth-kit/hooks/useSignOut";
import { useNavigate } from "react-router-dom";
import Notifications from "./Notifications";
import { useDispatch } from "react-redux";
import { setCurrency } from "../../store/currencySlice";

const Header1 = ({ onDrawerToggle, heading }) => {
  const navigate = useNavigate();
  const signOut = useSignOut();

  const [anchorEl, setAnchorEl] = useState(null);
  const [username, setUsername] = useState("");
  const [useremail, setUseremail] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userData = await fetchUsernameAndEmail();
        setUsername(userData.fullName);
        setUseremail(userData.email);
        dispatch(setCurrency(process.env.REACT_APP_CURRENCY));
      } catch (error) {
        console.error("Failed to fetch user data:", error);
      }
    };

    fetchData();
  }, [dispatch]);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const LogoutFunc = async () => {
    signOut();
    Cookies.remove("fcmToken");
    navigate("/login");
  };

  return (
    <AppBar
      color="primary"
      sx={{ backgroundColor: colors.secondary, paddingTop: 1 }}
      position="sticky"
      elevation={0}
    >
      <Toolbar
        sx={{
          display: "flex",
          alignContent: "space-between",
          justifyContent: "space-between",
        }}
      >
        <Grid item sx={{ display: "block", "@media (min-width:600px) and (min-height:600px)": { display: "none",},}}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={onDrawerToggle}
            edge="start"
          >
            <MenuIcon />
          </IconButton>
        </Grid>
        <Typography
          color={colors.primary}
          sx={{
            typography: {
              xs: "h6",
              md: "h5",
            },
          }}
        >
          {heading}
        </Typography>
        <Grid item xs />
        <Grid item>
          <Notifications />
        </Grid>
        <Grid item>
          <IconButton color="inherit" sx={{ p: 0.5 }} onClick={handleMenuOpen}>
            <Avatar
              color={colors.primary}
              name={username}
              round="100px"
              size="35px"
              style={{ fontWeight: 700 }}
            />
          </IconButton>

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            MenuListProps={{
              dense: true,
              sx: {
                p: 0,
              },
            }}
          >
            <Box sx={{ bgcolor: colors.mainContentBgColor, overflowX: "auto" }}>
              <MenuItem
                sx={{
                  minWidth: "200px",
                  fontSize: "15px",
                  padding: "5px 20px",
                  paddingTop: "10px",
                  cursor: "default",
                  justifyContent: "center",
                  whiteSpace: "nowrap", // Prevent text wrapping
                }}
                disableTouchRipple
                disableRipple
              >
                {username}
              </MenuItem>
              <MenuItem
                sx={{
                  minWidth: "200px",
                  fontSize: "15px",
                  padding: "5px 20px",
                  cursor: "default",
                  justifyContent: "center", // Center the username
                  whiteSpace: "nowrap", // Prevent text wrapping
                }}
                disableTouchRipple
                disableRipple
              >
                {useremail}
              </MenuItem>
              <Divider sx={{ height: "2px", bgcolor: colors.background }} />
              <MenuItem
                sx={{
                  minWidth: "200px",
                  fontSize: "13px",
                  padding: "5px 20px",
                  gap: "10px",
                  whiteSpace: "nowrap", // Prevent text wrapping
                }}
                onClick={() => navigate("change-password")}
              >
                <KeyIcon />
                Change Password
              </MenuItem>
              <MenuItem
                sx={{
                  minWidth: "200px",
                  fontSize: "13px",
                  padding: "5px 20px",
                  paddingBottom: "10px",
                  gap: "10px",
                  whiteSpace: "nowrap", // Prevent text wrapping
                }}
                onClick={LogoutFunc}
              >
                <LogoutIcon />
                Logout
              </MenuItem>
            </Box>
          </Menu>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

Header1.propTypes = {
  onDrawerToggle: PropTypes.func.isRequired,
};

export default Header1;
